import { DocumentTemplate } from '@thedealersconcierge/lib/pdf-gen';
import { legalStamps } from '@thedealersconcierge/lib/pdf-gen/templates/legal-stamp';

type Fields =
  | 'phoneNumber'
  | 'email'
  | 'name'
  | 'dateTime'
  | 'deviceId'
  | 'ipAddress';

export const contactAcknowledgement: DocumentTemplate<Fields> = {
  fileUrl: '/docs/contact-acknowledgement.pdf',
  fields: {
    phoneNumber: {
      formFieldId: 'form-contact-acknowledgement-field-1',
      formId: 'form-contact-acknowledgement',
      demoData: '(555) 123 4323',
      formFieldPlacements: [
        {
          formFieldPlacementId:
            'form-contact-acknowledgement-field-1-placement-1',
          positionX: 200,
          positionY: 242,
          page: 0,
          width: 150,
          height: 30,
          textFontSize: null,
          characterListSpacing: null,
          textItalic: false,
          textBold: false,
          textUnderline: false
        }
      ],
      type: 'TEXT',
      createdAt: '2024-05-21 00:00:00.000'
    },
    email: {
      formFieldId: 'form-contact-acknowledgement-field-2',
      formId: 'form-contact-acknowledgement',
      demoData: 'test@example.com',
      formFieldPlacements: [
        {
          formFieldPlacementId:
            'form-contact-acknowledgement-field-2-placement-1',
          positionX: 200,
          positionY: 296,
          page: 0,
          width: 150,
          height: 30,
          textFontSize: null,
          characterListSpacing: null,
          textItalic: false,
          textBold: false,
          textUnderline: false
        }
      ],
      createdAt: '2024-05-21 00:00:00.000',
      type: 'TEXT'
    },
    ...legalStamps('form-contact-acknowledgement', [0])
  }
};
